<script>
    export let source;

    import REST from '../RESTClass.js';
    import { watchResize } from "svelte-watch-resize";
    import { setMoverVisibility } from '../Utils';

    import Card from '../Components/Card/Card.svelte';
    import Mover from '../Components/Mover/Mover.svelte';

    let newsData;
    let moverVisible = true;

    const API = new REST();
    
    if (source.hook == 'artists') {
        API.getFromArtistsLife()
            .then(data => newsData = data);
    } else if (source.hook == 'church') {
        API.getFromChurchLife()
            .then(data => newsData = data);
    }

</script>

<section class="news">
    <h2 class="padded">{source.title}</h2>
    <div use:watchResize={node => moverVisible = setMoverVisibility(node)} class="latest padded">
        {#if newsData}
            {#each newsData as entry}
                <Card 
                    type="news"
                    content={{
                        date: entry.timestamp,
                        description: entry.tag,
                        hours: entry.hours,
                        thumbnail: entry.thumbnail,
                        title: entry.title,
                        url: entry.url
                    }}
                    props={{
                        spaced: true
                    }}
                />
            {/each}
        {/if}
    </div>
    <Mover 
        props={{
            range: 200,
            visible: moverVisible
        }}
    />
</section>

<style type="text/scss">
    h2 {
        color: #c2ae8d;
        font-family: 'Rufina', serif;
        font-size: 18px;
        margin: 1.2rem 0;
        text-transform: uppercase;
    }

    .latest {
        display: flex;
        overflow-x: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
</style>